import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    PrestadorCorpoSocietarioCargoResponse,
    PrestadorCorpoSocietarioPage,
    PrestadorCorpoSocietarioParams,
    PrestadorCorpoSocietarioSaidaEmLoteRequest,
    PrestadorCorpoSocietarioSocioAtualizarRequest,
    PrestadorCorpoSocietarioSocioRemoverRequest,
    PrestadorCorpoSocietarioSocioSalvarRequest
} from '@/core/api/sicom-api/registro/prestador/prestador-corpo-societario.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorCorpoSocietarioService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.corpoSocietario;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listar(params: PrestadorCorpoSocietarioParams, context?: HttpContext): Observable<PrestadorCorpoSocietarioPage> {
        const httpParams = new HttpParams()
            .set('id', String(params.id))
            .set('uf', params.uf)
            .set('composicao', params.composicao)
            .set('sortBy', params.sortBy)
            .set('direction', params.direction)
            .set('page', String(params.page))
            .set('size', String(params.size));

        return this.http.get<PrestadorCorpoSocietarioPage>(this.PATH, { params: httpParams, context });
    }

    listarCargos(context?: HttpContext): Observable<PrestadorCorpoSocietarioCargoResponse[]> {
        return this.http.get<PrestadorCorpoSocietarioCargoResponse[]>(`${this.PATH}/cargos`, { context });
    }

    criar(request: PrestadorCorpoSocietarioSocioSalvarRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(this.PATH, request, { context });
    }

    atualizar(request: PrestadorCorpoSocietarioSocioAtualizarRequest, context?: HttpContext): Observable<void> {
        return this.http.put<void>(this.PATH, request, { context });
    }

    remover(request: PrestadorCorpoSocietarioSocioRemoverRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(this.PATH, { body: request, context });
    }

    informarSaidaEmLote(request: PrestadorCorpoSocietarioSaidaEmLoteRequest, context?: HttpContext): Observable<void> {
        return this.http.patch<void>(`${this.PATH}/saida-em-lote`, request, { context });
    }
}
